import { Popup, type PopupProps } from "react-map-gl/mapbox";

// Strip Mapbox's default popup box (white bg, padding, shadow) so the card
// rendered inside *is* the popup, but keep the tip — given a soft shadow so it
// reads as the card's tail. Mapbox colours the tip white per anchor by default.
const CHROME =
  "[&_.mapboxgl-popup-content]:!bg-transparent [&_.mapboxgl-popup-content]:!p-0 [&_.mapboxgl-popup-content]:!shadow-none [&_.mapboxgl-popup-tip]:![filter:drop-shadow(0_2px_2px_rgba(0,0,0,0.08))]";

/**
 * `react-map-gl` Popup preconfigured for Travily's chrome-less map cards: no
 * default close button (cards render their own), no close-on-click, and a wide
 * `maxWidth` so the listing card isn't clipped. The `anchor` is left unset so
 * Mapbox auto-positions the card (top/bottom/left/right + corners) to keep it
 * on-screen near edge pins, with the tip pointing at the marker.
 */
export function MapPopup({ className, children, ...props }: PopupProps) {
  return (
    <Popup
      closeButton={false}
      closeOnClick={false}
      maxWidth="none"
      {...props}
      className={className ? `${CHROME} ${className}` : CHROME}
    >
      {children}
    </Popup>
  );
}
